"use strict";

$(document).ready(function () {});
"use strict";

$(document).ready(function () {});
"use strict";

$(document).ready(function () {});
"use strict";

$(document).ready(function () {});
"use strict";

$(document).ready(function () {});
"use strict";

$(document).ready(function () {});
"use strict";

$(document).ready(function () {});
"use strict";
"use strict";

$(document).ready(function () {});
"use strict";
'use strict';

$(document).ready(function () {
    $('.note.note--success').each(function () {
        $([document.documentElement, document.body]).animate({
            scrollTop: $(this).offset().top - $(window).height() / 2
        }, 0);
    });
    var checkForm = setInterval(function () {
        $('#CartSoumission').each(function () {
            if ($(this).find('.soumission-form #hidden').length) {
                $(this).find('.soumission-form .submit').addClass('btn');
                var soumissionProducts = $(this).find('.soumission-products').html();
                soumissionProducts = soumissionProducts.replace(/(?:\r\n|\r|\n)/g, '');
                $(this).find('.soumission-form #hidden').val(soumissionProducts);
                clearInterval(checkForm);
            }
        });
    }, 100);
});